export const stringTrim = (str) => (str ? str.trim() : '');
